import React from "react";
import ExamCalculatorState, { ExamCalculatorProps, ExamPercentDTO } from "./ExamCalculator.models";
import './ExamCalculator.scss';
import { Modal } from "react-bootstrap";
import ExamCalculatorImage from '../../../assest/images/card-image/item-pencil-avatar@3x.png';
import SelectInput from "../../shared/select/SelectInput";
import StudentBaseService from "../../../services/education/StudentBaseService";
import CourseService from "../../../services/education/CourseService";
import AuthContext from "../../../contexts/AuthContext";
import { toast } from "react-toastify";
import ExamService from "../../../services/exam/ExamService";

export default class ExamCalculator extends React.PureComponent<ExamCalculatorProps, ExamCalculatorState>{
    studentBaseService: StudentBaseService;
    courseService: CourseService;
    examService: ExamService;
    static contextType = AuthContext
    context!: React.ContextType<typeof AuthContext>;
    constructor(props: any) {
        super(props);
        this.studentBaseService = new StudentBaseService();
        this.courseService = new CourseService();
        this.examService = new ExamService();
        this.state = { courses: [], studentBases: [], submitExamResultForm: {}, showModal: false, calculate: 0, saveExamPercent: false };
    }

    componentDidMount = () => {
        let self = this;

        self.getStudentBase();
    }

    getStudentBase() {
        let self = this;

        self.studentBaseService.getBaseTitleValueByStudentId().then(function (response) {
            self.setState({ studentBases: response });
        })
    }

    getCourse(value: any) {
        let self = this;

        if (value !== null && value !== "" && value !== undefined) {
            self.courseService.getTitleValueCoursesActive(value, this.context.userInformation?.education?.fieldId ?? 0).then(function (response) {
                self.setState({ courses: response });
            })
        }
    }

    setBaseSelected = (value: any) => {
        this.setState((prevState) => {
            return { submitExamResultForm: { ...prevState.submitExamResultForm, studentBaseId: value } }
        });

        if (value !== null && value !== "" && value !== undefined)
            this.getCourse(value);
        else
            this.setState({ courses: [] });
    }

    setCourseSelected = (value: any) => this.setState((prevState) => {
        return { submitExamResultForm: { ...prevState.submitExamResultForm, courseId: value } }
    });


    calculatorStudentCourseExam = (successfulAnswers: number, wrongAnswers: number, Unanswered: number): number => {
        if (successfulAnswers === 0 && wrongAnswers === 0 && Unanswered === 0)
            return 0;

        let totalQuestions = successfulAnswers + wrongAnswers + Unanswered;
        let percentNumber = (successfulAnswers * 3);
        percentNumber = (percentNumber - wrongAnswers);
        percentNumber = (percentNumber / (totalQuestions * 3)) * 100;

        let percentString = "";
        if (percentNumber.toString().includes('.')) {
            let strPercent = percentNumber.toString().split('.');
            let stingPercent = strPercent[0];
            if (strPercent[1].length >= 1)
                stingPercent += "." + strPercent[1][0];

            if (strPercent[1].length >= 2)
                stingPercent += strPercent[1][1];
            percentString = stingPercent;
        }
        else {
            percentString = percentNumber.toString();
        }

        let result = Number.parseInt(percentString);

        if (result > 100)
            result = 100;
        else if (result < -100)
            result = -100;

        return result;

    }

    examCalculator = () => {
        let self = this;
        let state = this.state;

        if (state.saveExamPercent && (!state.submitExamResultForm.studentBaseId || !state.submitExamResultForm.courseId))
            return toast.error("لطفا اطلاعات را تکمیل کنید.")

        let percent = self.calculatorStudentCourseExam(state.submitExamResultForm.correctId ?? 0, state.submitExamResultForm.wrongId ?? 0, state.submitExamResultForm.unansweredId ?? 0);

        self.setState({ calculate: percent, showModal: !state.saveExamPercent }, () => {
            if (state.saveExamPercent)
                this.savePercent();
        });

    }

    savePercent = () => {
        let { submitExamResultForm, calculate } = this.state;
        let body: ExamPercentDTO = {
            correctAnswers: submitExamResultForm.correctId ?? 0,
            unAnswered: submitExamResultForm.unansweredId ?? 0,
            wrongAnswers: submitExamResultForm.wrongId ?? 0,
            courseId: submitExamResultForm.courseId as number,
            studentBaseID: submitExamResultForm.studentBaseId as number,
            examPercent: calculate,
            studentFieldID: this.context.userInformation?.education?.fieldId ?? 0
        }

        this.examService.saveExamPercent(body).finally(() => {
            this.setState({ showModal: true })
        })
    }

    clear = () => {
        this.setState({ submitExamResultForm: { correctId: 0, unansweredId: 0, wrongId: 0, courseId: undefined, studentBaseId: undefined }, saveExamPercent: false });
    }

    showModal = () => {
        this.setState({ showModal: true });
    }

    closeModal = () => {
        this.setState({ showModal: false });
    }

    render(): React.ReactNode {
        let { showModal, submitExamResultForm, saveExamPercent, calculate, courses, studentBases } = this.state;
        let modal;
        modal = (<>
            <Modal show={showModal} onHide={this.closeModal} animation={true}>
                <Modal.Header >
                    <Modal.Title>
                        <label>محاسبه درصد عملکرد آزمون</label>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ textAlign: 'initial' }}>
                        <div className="col-12 bd-modal">
                            <label>تعداد سوالات صحیح: {submitExamResultForm.correctId}</label>
                        </div>
                        <div className="col-12 bd-modal">
                            <label>تعداد سوالات غلط: {submitExamResultForm.wrongId}</label>
                        </div>
                        <div className="col-12 bd-modal">
                            <label>تعداد سوالات بدون پاسخ: {submitExamResultForm.unansweredId}</label>
                        </div>
                        <div className="col-12 bd-modal">
                            <label>درصد عملکرد شما در این ازمون:</label>
                            <label>%{Math.round(calculate)} </label>
                        </div>
                        {
                            saveExamPercent && <>
                                {
                                    submitExamResultForm.studentBaseId && <div className="col-12 bd-modal">
                                        <label>پایه:</label>
                                        <label>{studentBases.filter(studentBase => studentBase.value == submitExamResultForm.studentBaseId)[0].title}</label>
                                    </div>
                                }
                                {
                                    submitExamResultForm.courseId && <div className="col-12 bd-modal">
                                        <label>درس: </label>
                                        <label>{courses.filter(course => course.value == submitExamResultForm.courseId)[0].title}</label>
                                    </div>
                                }
                            </>
                        }
                    </div>
                </Modal.Body >

                <Modal.Footer dir="ltr">
                    <button className="btn btn-primary left" onClick={this.closeModal}>بستن</button>
                </Modal.Footer>
            </Modal >
        </>);
        return (<>

            <div className="exam-calculator-area">
                <div className="dropdown-list ">
                    <div className="tk-card">
                        <div className="col-12">
                            <div className="icon">
                                <img src={ExamCalculatorImage} width="64" height="64" alt="exam calculator icon" />
                            </div>
                            <div className="title">
                                <label style={{ paddingRight: '52px' }}>ماشین حساب آزمون</label>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="tk-boby">
                                <div className="bd-title sub-title">
                                    <label>اطلاعات آزمون مورد نظر خود را وارد کنید</label>
                                </div>
                                <div className="exam-content">
                                    <div className="tk-padding-12">
                                        <label className="placholder">تعداد سوالات صحیح</label>
                                        <input type="number" className="form-control" value={submitExamResultForm.correctId} onChange={e => this.setState((prevState) => { return { submitExamResultForm: { ...prevState.submitExamResultForm, correctId: e.target.value !== '' ? Number.parseInt(e.target.value) : undefined } } })} placeholder="تعداد سوالات صحیح" />
                                    </div>
                                    <div className="tk-padding-12">
                                        <label className="placholder" >تعداد سوالات غلط</label>
                                        <input type="number" className="form-control" value={submitExamResultForm.wrongId} onChange={e => this.setState((prevState) => { return { submitExamResultForm: { ...prevState.submitExamResultForm, wrongId: e.target.value !== '' ? Number.parseInt(e.target.value) : undefined } } })} placeholder="تعداد سوالات غلط" />
                                    </div>
                                    <div className="tk-padding-12">
                                        <label className="placholder">تعداد سوالات بدون پاسخ</label>
                                        <input type="number" className="form-control" value={submitExamResultForm.unansweredId} onChange={e => this.setState((prevState) => { return { submitExamResultForm: { ...prevState.submitExamResultForm, unansweredId: e.target.value !== '' ? Number.parseInt(e.target.value) : undefined } } })} placeholder="تعداد سوالات بدون پاسخ" />
                                    </div>
                                </div>
                                <div className="exam-content mt-4">
                                    <div className="pd-Checkbox">
                                        <label className="container">
                                            <input checked={saveExamPercent} type={"checkbox"} onChange={() => this.setState({ saveExamPercent: !saveExamPercent })} />
                                            <span className="checkmark" style={{ right: 0 }}></span>
                                        </label>
                                        <label style={{ paddingRight: '32px' }}>ثبت درصد این آزمون در عملکرد شما</label>
                                    </div>
                                    {
                                        saveExamPercent && <>
                                            <div className="sub-title">
                                                <label>جهت ثبت درصد این آزمون اطلاعات را تکمیل کنید</label>
                                            </div>
                                            <div className="tk-padding-bottom">
                                                <label htmlFor="studentBase">پایه:</label>
                                                <SelectInput inputvalue={submitExamResultForm.studentBaseId} datas={studentBases} value={this.setBaseSelected} isNullAble={false} name='studentBase' />
                                            </div>
                                            <div className="tk-padding-bottom">
                                                <label htmlFor="course">درس:</label>
                                                <SelectInput inputvalue={submitExamResultForm.courseId} datas={courses} value={this.setCourseSelected} isNullAble={false} name='course' />
                                            </div>
                                        </>
                                    }
                                </div>
                                <div className="tk-footer">
                                    <button type="submit" className="btn btn-primary tk-full-width" onClick={this.examCalculator}>محاسبه</button>
                                    <label className="btn btn-outline-warning tk-full-width mt-2" onClick={this.clear}>بازنشانی</label>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            {showModal && modal}
        </>);
    }
}